// store/slices/measureSlice.ts

import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { MeasureMode, MeasureSegment } from "../../plugins/measure/types";
import type { Coordinate } from "../../plugins/draw/types";

interface MeasureState {
  mode: MeasureMode;
  segments: MeasureSegment[]; // completed — stay on map until clearMeasure()
  livePoints: Coordinate[]; // in-progress clicked points
  mousePos: Coordinate | null; // cursor position for rubber-band preview
  liveResult: string; // real-time formatted measurement
  editingSegmentId: string | null; // which segment is being edited
}

const initialState: MeasureState = {
  mode: "NONE",
  segments: [],
  livePoints: [],
  mousePos: null,
  liveResult: "",
  editingSegmentId: null,
};

const measureSlice = createSlice({
  name: "measure",
  initialState,
  reducers: {
    setMeasureMode(state, action: PayloadAction<MeasureMode>) {
      state.mode = action.payload;
    },
    setMeasureSegments(state, action: PayloadAction<MeasureSegment[]>) {
      state.segments = action.payload;
    },
    setLivePoints(state, action: PayloadAction<Coordinate[]>) {
      state.livePoints = action.payload;
    },
    setMousePos(state, action: PayloadAction<Coordinate | null>) {
      state.mousePos = action.payload;
    },
    setLiveResult(state, action: PayloadAction<string>) {
      state.liveResult = action.payload;
    },
    setEditingSegmentId(state, action: PayloadAction<string | null>) {
      state.editingSegmentId = action.payload;
    },
    addSegment(state, action: PayloadAction<MeasureSegment>) {
      state.segments.push(action.payload);
    },
    removeSegment(state, action: PayloadAction<string>) {
      console.log("action.payload", action.payload);

      state.segments = state.segments.filter((s) => s.id !== action.payload);
    },
    clearSegments(state) {
      state.mode = "NONE";
      state.segments = [];
      state.livePoints = [];
      state.mousePos = null;
      state.liveResult = "";
      state.editingSegmentId = null;
    },
  },
});

export const {
  setMeasureMode,
  setMeasureSegments,
  setLivePoints,
  setMousePos,
  setLiveResult,
  setEditingSegmentId,
  addSegment,
  removeSegment,
  clearSegments,
} = measureSlice.actions;
export default measureSlice.reducer;
